import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4F4D8C",
    },
    secondary: {
      main: "#8F8EBF",
    },
  },
  components: {},
  typography: {
    h1: {
      fontSize: "50px",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 980,
      lg: 1200,
      xl: 1536,
    },
  },
});

export const myConstants = {
  myConstant: "100px",
};

